import { makeStyles } from "@material-ui/core";

export const useAdditionalResourcesStyles = makeStyles(() => ({
    listWrapper: {
        paddingBottom: 64
    }
}));
